export default __webpack_public_path__ + "static/media/logo_plasoft.6856e127.png";